export class MembershipLevelOption {
    value: number;
    text: string;
}
